import * as colors from 'HubStyleTokens/colors';
import UIIconCircle from 'UIComponents/icon/UIIconCircle';
import { jsx as _jsx } from "react/jsx-runtime";
export default function VideoIconOverlay() {
  return /*#__PURE__*/_jsx("div", {
    className: "video-icon-overlay align-center justify-center",
    children: /*#__PURE__*/_jsx(UIIconCircle, {
      "data-test-id": "video-icon-overlay",
      name: "playerPlay",
      color: colors.OLAF,
      backgroundColor: colors.OBSIDIAN,
      borderWidth: 0,
      size: 9,
      padding: 0.2,
      iconClassName: "m-right-0"
    })
  });
}